import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

export const useTokenValidation = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const validateToken = async (token: string) => {
    setIsLoading(true);
    setError(null);

    try {
      console.log("Starting custom token validation process...");
      console.log("Token:", token);
      
      if (!token.trim()) {
        throw new Error("El código de recuperación es requerido");
      }

      // Validar el token mediante función SECURITY DEFINER (no exponer la tabla)
      const { data: result, error: rpcError } = await supabase
        .rpc('validate_password_reset_token', { _token: token.trim() });

      if (rpcError) {
        console.error("RPC error:", rpcError);
        throw new Error("Error al verificar el código de recuperación.");
      }

      const payload = result as { valid: boolean; email: string | null } | null;

      if (!payload || !payload.valid || !payload.email) {
        throw new Error("El código de recuperación no es válido o ha expirado.");
      }

      // Guardar el email y token para el proceso de cambio de contraseña
      localStorage.setItem('recovery_email', payload.email);
      localStorage.setItem('recovery_token', token.trim());
      
      // Redirigir a la página de cambio de contraseña
      navigate("/change-password", { replace: true });
      
    } catch (error: any) {
      console.error("Token validation error details:", error);

      let errorMessage = "El código de recuperación no es válido o ha expirado.";
      
      if (error.message.includes('expired')) {
        errorMessage = "El código de recuperación ha expirado. Por favor, solicita uno nuevo.";
      } else if (error.message.includes('invalid')) {
        errorMessage = "El código de recuperación no es válido. Por favor, verifica e intenta nuevamente.";
      } else if (error.message.includes('email')) {
        errorMessage = error.message;
      }

      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    validateToken
  };
};